export default "__VITE_ASSET__B1mFR1wW__"